import { render, staticRenderFns } from "./MultipleFormsCopy.vue?vue&type=template&id=77481cc0&scoped=true"
import script from "./MultipleFormsCopy.vue?vue&type=script&lang=js"
export * from "./MultipleFormsCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77481cc0",
  null
  
)

export default component.exports